import { render, staticRenderFns } from "./bracelet.vue?vue&type=template&id=59d8d758&scoped=true&"
import script from "./bracelet.vue?vue&type=script&lang=js&"
export * from "./bracelet.vue?vue&type=script&lang=js&"
import style0 from "./bracelet.vue?vue&type=style&index=0&id=59d8d758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8d758",
  null
  
)

export default component.exports